import React, { FC } from 'react';
import ProfileItem from '#modules/profileSelection/profilelist/profile-item/ProfileItem';
import { UserProfile } from '#types';
import AddProfileButton from '#modules/profileSelection/profilelist/add-button/AddProfileButton';
import { MAX_PROFILE_COUNT } from '#config/constants';
import useResortPass from '#hooks/useResortPass';

type Props = {
  title?: string;
  profiles: UserProfile[];
  mode?: 'edit' | 'select';
  selectedProfileId?: number;
  showAddButton?: boolean;
  onAddButtonClick?: () => void;
  onSelect?: (profile: UserProfile) => void;
  onDelete?: (profile: UserProfile) => void;
  onItemClick?: (profile: UserProfile) => void;
};

const UserList: FC<Props> = ({
  title,
  profiles,
  selectedProfileId,
  mode = 'select',
  onSelect,
  onDelete,
  onItemClick,
  onAddButtonClick,
}) => {
  let maxNumberOfProfiles = MAX_PROFILE_COUNT;
  const { hasResortPass, resortPassWalletCount } = useResortPass();
  if (hasResortPass) {
    maxNumberOfProfiles += resortPassWalletCount;
  }

  return (
    <div className="tw-flex tw-flex-col" aria-labelledby={title} role="group">
      <strong className="tw-sr-only" id={title}>
        {title}
      </strong>
      <ul className="tw-flex tw-flex-wrap tw-justify-center tw-gap-12 tw-mx-auto">
        {profiles.map((profile) => {
          const selected = profile.id === selectedProfileId;
          const deletable = mode === 'edit' && profiles.length > 1 && !selected;

          return (
            <li key={profile.id} data-testid="profile-selection-item">
              <ProfileItem
                deletable={deletable}
                selected={selected}
                profile={profile}
                onSelect={onSelect}
                onDelete={onDelete}
                onClick={onItemClick}
                mode={mode}
              />
            </li>
          );
        })}

        {mode !== 'edit' && profiles.length < maxNumberOfProfiles && (
          <li key="new-profile" data-testid="profile-add-button">
            <AddProfileButton onClick={onAddButtonClick} />
          </li>
        )}
      </ul>
    </div>
  );
};

export default UserList;
